/**
 * @param {string} source path to the script to load
 * @returns {Promise<void>} retourne une promesse qui se résout quand le script a été executé
 */
export function loadScript(source) {
  return new Promise((resolve, reject) => {
    // si le script est déjà présent ne le rajoute pas
    if (document.querySelector('script[src="' + source + '"]')) resolve()

    let script = document.createElement('script')
    document.head.appendChild(script)

    script.async = false
    script.defer = true

    script.onload = script['onreadystatechange'] = function (_, isAbort) {
      if (isAbort || !script['readyState'] || /loaded|complete/.test(script['readyState'])) {
        script.onload = script['onreadystatechange'] = null

        if (isAbort) reject('failed to load script "' + source + '"')
        else resolve()
      }
    }

    script.src = source
  })
}
